module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dof-cell",
    class: ['wrapper', _vm.hasMargin && 'cell-margin'],
    style: _vm.cellStyleComp
  }, [_c('div', {
    class: ['cell-wrapper', _vm.disabled ? 'cell-disabled-opacity' : 'cell-abled-opacity']
  }, [_c('div', {
    class: ['dof-cell', _vm.hackMrgb1pxcom && 'mgb-1', !_vm.disabled && _vm.isHighlight && 'dof-cell-highlight'],
    style: _vm.borderStyleComp,
    attrs: {
      "accessible": _vm.autoAccessible,
      "ariaLabel": (_vm.label + "," + _vm.title + "," + _vm.desc)
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default", [(_vm.avatarIcon || _vm.avatarIconFont) ? _c('div', {
    staticClass: ["left", "img-wrapper"]
  }, [(_vm.avatarIcon) ? _c('div', {
    staticClass: ["img-container", "circle-bg"],
    class: [_vm.badgeNum && 'Dotright32'],
    style: _vm.avatarIconBgSizeComp
  }, [_vm._t("leftImg", [_c('image', {
    staticClass: ["left-img"],
    style: _vm.avatarIconSizeComp,
    attrs: {
      "src": _vm.avatarIcon
    }
  })])], 2) : _vm._e(), (_vm.avatarIconFont) ? _c('div', {
    staticClass: ["circle-bg"]
  }, [_vm._t("leftIconFont", [_c('dof-iconfont', {
    attrs: {
      "code": _vm.avatarIconFont,
      "size": _vm.avatarIconFontSize,
      "color": _vm._isColmo ? 'rgba(255,255,255,0.80)' : '#1E2E37'
    }
  })])], 2) : _vm._e(), (_vm.hasDot) ? _c('div', {
    staticClass: ["dot-tip"],
    class: [_vm.badgeNum && 'dotRight', _vm.dotTipTop],
    style: _vm.badgeStyle
  }) : (_vm.badgeNum) ? _c('div', {
    staticClass: ["dot-num-tip"],
    style: _vm.badgeStyle
  }, [_c('text', {
    staticClass: ["dot-num-tip-text"]
  }, [_vm._v(_vm._s(_vm.dotNum))])]) : _vm._e()]) : _vm._e(), _c('div', {
    class: ['main-container', _vm.hasVerticalIndent && 'cell-indent', _vm.badgeNum && 'notDot'],
    style: _vm.subBorderStyleComp
  }, [_vm._t("label", [(_vm.label) ? _c('div', [_c('text', {
    staticClass: ["cell-label-text"],
    style: _vm.textColorComp
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()]), _c('div', {
    class: ['middle', _vm.desc ? 'has-desc' : 'no-desc'],
    style: _vm.innerCellHeightComp
  }, [_vm._t("middle", [_c('div', {
    staticClass: ["cell-title-wrapper"]
  }, [_c('div', {
    class: ['cell-title-content', !_vm.tag && 'title-flex-expand']
  }, [_c('div', {
    class: ['cell-title']
  }, [_c('text', {
    class: ['cell-title-text', !_vm.hasTextTip && 'title-flex-expand'],
    style: _vm.titleStyleComp
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.hasTextTip) ? _c('div', {
    staticClass: ["text-dot-tip"]
  }) : _vm._e()])]), _vm._t("tag", [(_vm.tag) ? _c('div', {
    staticClass: ["cell-title-tag"],
    style: {
      backgroundColor: _vm.iconColor ? _vm.iconColor : _vm._isDiablo ? '#2b2f32' : '#F6F7F9'
    }
  }, [_c('text', {
    staticClass: ["cell-title-tag-text"]
  }, [_vm._v(_vm._s(_vm.tag))])]) : _vm._e()])], 2), (_vm.desc) ? _c('div', {
    class: ['cell-desc-wrapper', !_vm.tag && !_vm._isColmo && 'margin-top-24']
  }, [_vm._t("desc", [_c('div', {
    staticClass: ["cell-desc"]
  }, [_c('text', {
    staticClass: ["cell-desc-text"],
    style: _vm.descStyleComp
  }, [_vm._v(_vm._s(_vm.desc))])])])], 2) : _vm._e()])], 2), _c('div', {
    class: ['right', _vm.rightTip && 'has-no-padding-left']
  }, [_vm._t("rightText", [(_vm.rightText) ? _c('div', {
    staticClass: ["right-text-wrapper"]
  }, [_c('text', {
    class: [
      'right-text',
      !_vm.avatarIcon && 'single-line-text',
      _vm.avatarIcon && _vm.iconSize === 'big' && 'normal-right-text'
    ],
    style: _vm.rightTextStyleComp
  }, [_vm._v(_vm._s(_vm.rightText))])]) : _vm._e()]), (_vm.extraContent) ? _c('text', {
    staticClass: ["extra-content-text"],
    style: _vm.textColorComp
  }, [_vm._v(_vm._s(_vm.extraContent))]) : _vm._e(), _vm._t("switch"), (_vm.hasArrow) ? _c('div', {
    staticClass: ["arrow-wrapper"]
  }, [_vm._t("arrow", [(_vm._isColmo) ? _c('dof-iconfont', {
    staticStyle: {
      width: "34px"
    },
    attrs: {
      "code": '\u4713',
      "size": 48,
      "color": 'rgba(255,255,255,0.80)'
    },
    on: {
      "dofIconFontClicked": _vm.onClick
    }
  }) : _c('image', {
    staticClass: ["cell-arrow-icon"],
    attrs: {
      "src": _vm.arrowIcon,
      "ariaHidden": true
    }
  })])], 2) : _vm._e()], 2)], 2), (_vm.rightTip) ? _c('div', {
    class: [
      'right-tip-wrapper',
      _vm.hasTopSubBorder && 'cell-top-border',
      _vm.hasSubBottomBorder && 'cell-bottom-border',
      _vm.special && 'space-gap'
    ]
  }, [_vm._t("rightTip", [_c('text', {
    staticClass: ["right-tip-text"],
    on: {
      "click": _vm.dofRightTipClicked
    }
  }, [_vm._v(_vm._s(_vm.rightTip))])])], 2) : _vm._e()])], 2)]), (_vm.useFakeBorder) ? _c('div', {
    staticClass: ["fake-border"],
    style: _vm.fakeBorderStyleRender
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-25ecf10a!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-cell/index.vue
// module id = 584
// module chunks = 0 1